/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useLayoutEffect, useRef } from "react"
import { LANDING_EDIT_MODE } from "src/modules/pe-landing-module/data/interfaces"
import { ILandingConsoleStore, ILandingStore, useLandingConsoleStore, useLandingStore } from "src/modules/pe-landing-module/data/store"
import undo from "./utils/undo"
import redo from "./utils/redo"
import { copyClipboard } from "src/libs/useful/ClipboardCopyBtn"
import { WINDOW_ICON, WINDOW_WIDTH } from "src/libs/interfaces/layouts"
import deleteSelected from "./utils/deleteSelected"
import resetPositionSelected from "./utils/resetPositionSelected"
import { IPanelStore, usePanelStore } from "../../UIX/store"
import saveLocal from "./utils/saveLocal"

/* Protopia Ecosystem component */
export interface IHotkeysProps {
   
}
const Hotkeys = (props: IHotkeysProps): JSX.Element => {
    const isHidePanels: boolean         = usePanelStore((state: IPanelStore) => state.isHidePanels)
    const modals: string[] 			    = useLandingStore((state: ILandingStore) => state.modals )
    const history 			            = useLandingStore((state: ILandingStore) => state.history )
    const currentHistoryStep 			= useLandingStore((state: ILandingStore) => state.currentHistoryStep )
    const currentLanding 			    = useLandingStore((state: ILandingStore) => state.currentLanding )
    const isEdit  					    = useLandingConsoleStore((state:ILandingConsoleStore) => state.isEdit )
    const editMode  					= useLandingConsoleStore((state:ILandingConsoleStore) => state.editMode )
    const settings  					= useLandingConsoleStore((state:ILandingConsoleStore) => state.settings )
    
    const onModal = (key: string) => {
        const isOpen = modals.includes(key) 
        useLandingStore.setState({
            modals: isOpen 
                ? 
                modals.filter((m: string) => m !== key) : [modals, key]
        }) 
    }
    const onKeyPress = ( evt: KeyboardEvent ) => {
        if(!isEdit) return 
        if( evt.ctrlKey ) {
            if(evt.code === "KeyE") {
                console.log("edit", evt)
                useLandingConsoleStore.setState( { editMode: LANDING_EDIT_MODE.EDIT } )
            }
            if(evt.code === "KeyD") {
                console.log("drag", evt)
                useLandingConsoleStore.setState( { editMode: LANDING_EDIT_MODE.DRAG } )
            }
            if(evt.code === "KeyI") {
                console.log("inner edit", evt)
                useLandingConsoleStore.setState( { editMode: LANDING_EDIT_MODE.INNER } )
            }
            if(evt.code === "KeyP") {
                console.log( "transform", evt)
                useLandingConsoleStore.setState( { editMode: LANDING_EDIT_MODE.TRANSFORM } )
            }
            if(!evt.shiftKey && evt.code === "KeyZ") {
                console.log( "undo", evt)
                undo()
            }
            if(evt.shiftKey && evt.code === "KeyZ") {
                console.log( "redo", evt)
                redo()
            }
            if( evt.shiftKey && evt.code === "KeyV" ) {
                console.log( "Preview", evt)
                useLandingConsoleStore.setState({ isEdit: false })
            }
            if( evt.code === "KeyC" && evt.altKey ) {
                const landing = useLandingStore.getState().currentLanding
                const dt = {
                    ...landing,
                    history,
                    currentHistoryStep, 
                }
                console.log( "Copy landing JSON", landing )
                copyClipboard({ 
                    isNotTrim: true, 
                    answer: "Landing data copied to clipboard",
                    data:dt
                })
                saveLocal(JSON.stringify(dt)) 
            }  

            (Object.keys(WINDOW_WIDTH) as (keyof typeof WINDOW_ICON)[])
                .filter((sz: keyof typeof WINDOW_ICON ) => {
                    return !!WINDOW_ICON[ sz ]
                })
                .forEach((sz: keyof typeof WINDOW_ICON, i ) => { 
                    if( evt.key === i.toString() ) {
                        useLandingConsoleStore.setState({ currentDimensionEdit: WINDOW_WIDTH[ sz ] })
                    }
                })
        }
        if( evt.altKey ) {
            if(evt.code === "KeyA") {
                console.log( evt )
                useLandingStore.setState({ isSectionEdit: true, sectionEditTab: "main", schema: "Landing", currentEditData: { ...currentLanding } })
            }
            if(evt.code === "KeyP") {
                console.log( evt )
                useLandingConsoleStore.setState( { settings: { ...settings, panels: !settings.panels } } )
            }
            if(evt.code === "KeyL") {
                console.log( evt )
                useLandingConsoleStore.setState( { settings: { ...settings, linesAndHandlers: !settings.linesAndHandlers } } )
            }
            if(evt.code === "KeyT") {
                console.log( evt )
                useLandingConsoleStore.setState( { settings: { ...settings, topPanel: !settings.topPanel } } )
            }
            if(evt.code === "KeyO") {
                //console.log( evt )
                useLandingConsoleStore.setState( { settings: { ...settings, toolPanel: !settings.toolPanel } } )

            }
            if(evt.code === "KeyS") {
                console.log( evt )

            }
            if(evt.code === "KeyH") {
                //console.log( evt )
                onModal( "hotkeys" )
            }
            if(evt.code === "KeyS") {
                //console.log( evt )
                onModal( "editor-settings" )
            }
            if( evt.code === "KeyR") {
                resetPositionSelected()
                evt.stopPropagation()
                evt.preventDefault()
            }
        }
        
        
        if( evt.code === "Delete") {
            deleteSelected()
        }
        if( evt.code === "Tab") {
            
            //console.log("tab", isHidePanels)            
            usePanelStore.setState({isHidePanels: !isHidePanels})
            evt.stopPropagation()
            evt.preventDefault()
        }
        // evt.stopPropagation()
        // evt.preventDefault()
        
    }
    useEffect(() => { 
        document.addEventListener("keydown", onKeyPress)

        return () => {
            document.removeEventListener("keydown", onKeyPress)
        }
    }, [])
    return <div className='position-absolute top left'>
       
    </div>
}
export default Hotkeys




type CombinationKey = "alt" | "ctrl" | "meta" | "shift";

export const useHotkeys = (
    key: string,
    combinationKey: null | CombinationKey,
    callback: (event: KeyboardEvent) => void
) => {
    const callbackRef = useRef(callback);

    useLayoutEffect(() => {
    callbackRef.current = callback;
    });

    useEffect(() => {
    const handler = (event: KeyboardEvent) => {
        if (
            (!combinationKey || event[`${combinationKey}Key`]) &&
            event.key === key
        ) {
            callbackRef.current(event);
        }
    };

    document.addEventListener("keydown", handler);
    return () => document.removeEventListener("keydown", handler);
    }, [key, combinationKey]);
};